module.exports = __webpack_public_path__ + "fonts/DINPro-Medium.8997699e.ttf";